export default function getResource(label, vars = []) {
    const resources = {
        orderNumber: 'Order Number'
    };
    return resources[label];
}
